import React from "react";

const STATUS_STYLES = {
  draft: "border-slate-200 bg-slate-50 text-slate-600",
  sent: "border-blue-200 bg-blue-50 text-blue-700",
  open: "border-blue-200 bg-blue-50 text-blue-700",
  unpaid: "border-blue-200 bg-blue-50 text-blue-700",
  viewed: "border-indigo-200 bg-indigo-50 text-indigo-700",
  partial: "border-amber-200 bg-amber-50 text-amber-700",
  partially_paid: "border-amber-200 bg-amber-50 text-amber-700",
  overdue: "border-rose-200 bg-rose-50 text-rose-700",
  paid: "border-emerald-200 bg-emerald-50 text-emerald-700",
  refunded: "border-violet-200 bg-violet-50 text-violet-700",
  void: "border-slate-200 bg-slate-50 text-slate-500",
  voided: "border-slate-200 bg-slate-50 text-slate-500",
  canceled: "border-slate-200 bg-slate-50 text-slate-500",
  cancelled: "border-slate-200 bg-slate-50 text-slate-500",
  uncollectible: "border-orange-200 bg-orange-50 text-orange-700",
};

export default function ClientInvoiceStatusBadge({ status }) {
  const normalized = String(status || "unknown").toLowerCase();
  const label = normalized.replaceAll("_", " ");

  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ${
        STATUS_STYLES[normalized] ||
        "border-slate-200 bg-slate-50 text-slate-600"
      }`}
    >
      {label}
    </span>
  );
}